import React, { useEffect } from 'react';

/**
 * The BingTracking component in TypeScript React is used to dynamically load a Bing tracking script on
 * page load.
 *
 * @returns In the provided code snippet, the `BingTracking` component is a functional component in
 * React that uses the `useEffect` hook to dynamically create and append a script element to the
 * document head for Bing tracking purposes.
 */
const BingTracking: React.FC = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = '(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"343176068", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");';
        document.head.appendChild(script);
    }, []);

    return null;
};

/**
 * The function `bingTrackingPurchaseEvent` creates a script element to track a purchase event on a webpage
 * using the Universal Event Tracking (UET) code.
 */
export const bingTrackingPurchaseEvent = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = 'window.uetq = window.uetq || [];window.uetq.push("event", "purchase", {"event_label":"purchase","event_value":1,"event_category":"purchase"});';
    document.head.appendChild(script);
};

export default BingTracking;
